import { useEffect, useState } from "react";

import { Box } from "@mui/material";

import useSurvey from "../../hooks/useSurvey";

const SkuMatrixStatus = ({
  section,
  questions,
  sku,
  answers,
  location,
  call,
}) => {
  const { getSkuMatrixStatus } = useSurvey();

  const [skuMatrixStatus, setSkuMatrixStatus] = useState({ colorCode: "#ccc" });

  useEffect(() => {
    let cancelled = false;
    const compute = async () => {
      const status = await getSkuMatrixStatus(
        section,
        questions,
        answers,
        location,
        call,
      );
      if (!cancelled) setSkuMatrixStatus(status);
    };

    compute();
    return () => {
      cancelled = true;
    };
  }, [section, questions, answers, location, call]);

  return (
    <Box
      sx={{
        width: "5px",
        height: "5px",
        backgroundColor: skuMatrixStatus.colorCode,
        margin: "1px",
        borderRadius: "50%",
      }}
    ></Box>
  );
};

export default SkuMatrixStatus;
